export const GET_ASSIGNED_REPS = 'GET_ASSIGNED_REPS';
export const SET_ASSIGNED_REPS = 'SET_ASSIGNED_REPS';
export const API_ERROR = 'LOGIN_API_ERROR';
export const SET_ASSIGNED_REP = 'SET_ASSIGNED_REP';
export const ADD_ASSIGNED_REP = 'ADD_ASSIGNED_REP';
export const EMPTY_ASSIGNED_REP = 'EMPTY_ASSIGNED_REP';
export const DELETE_ASSIGNED_REP = 'DELETE_ASSIGNED_REP';
export const EDIT_ASSIGNED_REP = 'EDIT_ASSIGNED_REP';
export const UPDATE_ASSIGNED_REP = 'UPDATE_ASSIGNED_REP';
export const SET_ASSIGNED_REP_FILTER = 'SET_ASSIGNED_REP_FILTER';